// ================================================================
// Canvas — صفحه اصلی که nodeها و خطوط روش رندر می‌شن
// ================================================================

import './canvas.css';
import { state } from '../../core/state.js';
import { events, EVENTS } from '../../core/events.js';
import { createNodeElement } from './Node.js';
import { renderConnections } from './Connection.js';

const SVG_NS = 'http://www.w3.org/2000/svg';

let canvasEl = null;
let nodesLayer = null;
let connectionsLayer = null;

let connectDrag = null;

export function renderCanvas(container) {
  container.innerHTML = `
    <div class="canvas" id="canvas-el">
      <svg class="canvas-connections" id="canvas-connections" xmlns="http://www.w3.org/2000/svg"></svg>
      <div class="canvas-nodes" id="canvas-nodes"></div>
    </div>
  `;

  canvasEl = container.querySelector('#canvas-el');
  nodesLayer = container.querySelector('#canvas-nodes');
  connectionsLayer = container.querySelector('#canvas-connections');

  redrawAll();

  events.on(EVENTS.NODE_ADDED, redrawAll);
  events.on(EVENTS.NODE_REMOVED, redrawAll);
  events.on(EVENTS.NODE_CONFIG_UPDATED, redrawAll);
  events.on(EVENTS.CONNECTION_ADDED, () => renderConnections(connectionsLayer));
  events.on(EVENTS.CONNECTION_REMOVED, () => renderConnections(connectionsLayer));
  events.on(EVENTS.CONNECTION_SELECTED, () => renderConnections(connectionsLayer));
  events.on(EVENTS.NODE_MOVED, () => renderConnections(connectionsLayer));
  events.on(EVENTS.LANGUAGE_CHANGED, redrawAll);
  events.on(EVENTS.SCENARIO_LOADED, redrawAll);

  // کلیک روی فضای خالی canvas → لغو انتخاب اتصال
  canvasEl.addEventListener('click', (e) => {
    if (e.target.closest('.connection-group')) return;
    if (e.target.closest('.node')) return;
    state.clearSelection();
  });

  // راست‌کلیک روی فضای خالی canvas → منوی افزودن نود آزاد
  canvasEl.addEventListener('contextmenu', (e) => {
    if (e.target.closest('.node')) return;
    if (e.target.closest('.connection-group')) return;
    e.preventDefault();
    const rect = canvasEl.getBoundingClientRect();
    events.emit(EVENTS.CONTEXT_MENU_OPEN, {
      type: 'canvas',
      x: e.clientX,
      y: e.clientY,
      canvasX: e.clientX - rect.left,
      canvasY: e.clientY - rect.top
    });
  });

  // کیبورد: Backspace/Delete → حذف اتصال انتخاب‌شده
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Backspace' && e.key !== 'Delete') return;
    // اگه داخل input/textarea تایپ می‌کنیم، کاری نکن
    const tag = (e.target.tagName || '').toLowerCase();
    if (tag === 'input' || tag === 'textarea' || e.target.isContentEditable) return;
    const sel = state.selectedConnection;
    if (!sel) return;
    e.preventDefault();
    state.removeConnection(sel.fromId, sel.toId);
    renderConnections(connectionsLayer);
  });

  events.on(EVENTS.CONNECT_DRAG_START, startConnectDrag);
}

function startConnectDrag({ fromId }) {
  const from = state.getNode(fromId);
  if (!from) return;

  const tempPath = document.createElementNS(SVG_NS, 'path');
  tempPath.setAttribute('class', 'connection-temp');
  tempPath.setAttribute('stroke', '#A6C8FF');
  tempPath.setAttribute('stroke-width', '3');
  tempPath.setAttribute('fill', 'none');
  tempPath.setAttribute('stroke-dasharray', '2 6');
  tempPath.setAttribute('stroke-linecap', 'round');
  connectionsLayer.appendChild(tempPath);

  connectDrag = { fromId, tempPath };

  document.addEventListener('mousemove', onConnectMove);
  document.addEventListener('mouseup', onConnectEnd);
  document.body.classList.add('connecting');
}

function onConnectMove(e) {
  if (!connectDrag) return;
  const from = state.getNode(connectDrag.fromId);
  if (!from) return;

  const rect = canvasEl.getBoundingClientRect();
  const x1 = from.x + 90;
  const y1 = from.y + 40;
  const x2 = e.clientX - rect.left;
  const y2 = e.clientY - rect.top;
  const midX = (x1 + x2) / 2;
  const d = `M ${x1} ${y1} C ${midX} ${y1}, ${midX} ${y2}, ${x2} ${y2}`;
  connectDrag.tempPath.setAttribute('d', d);

  const targetEl = document.elementFromPoint(e.clientX, e.clientY)?.closest('.node');
  nodesLayer.querySelectorAll('.node.connect-target').forEach(n => n.classList.remove('connect-target'));
  if (targetEl && Number(targetEl.dataset.id) !== connectDrag.fromId) {
    targetEl.classList.add('connect-target');
  }
}

function onConnectEnd(e) {
  if (!connectDrag) return;

  const targetEl = document.elementFromPoint(e.clientX, e.clientY)?.closest('.node');
  if (targetEl) {
    const toId = Number(targetEl.dataset.id);
    if (toId !== connectDrag.fromId) {
      state.addConnection(connectDrag.fromId, toId);
    }
  }

  connectDrag.tempPath.remove();
  nodesLayer.querySelectorAll('.node.connect-target').forEach(n => n.classList.remove('connect-target'));
  document.body.classList.remove('connecting');
  document.removeEventListener('mousemove', onConnectMove);
  document.removeEventListener('mouseup', onConnectEnd);
  connectDrag = null;
}

function redrawAll() {
  nodesLayer.innerHTML = '';
  state.nodes.forEach(nodeData => {
    const el = createNodeElement(nodeData, canvasEl);
    if (el) nodesLayer.appendChild(el);
  });
  renderConnections(connectionsLayer);
}
